export function sortclassify(val, result, num) {
  // console.log(val);

  if (result.length === num) return;
  result.push(val[0].label);
  if (val[0].children !== undefined) {
    sortclassify(val[0].children, result, num);
  }
}
